import { createContext } from "react";
import type { ShowMoreActivityContextType } from "./ShowMoreActivityContext.types";

const ShowMoreActivityContext = createContext<ShowMoreActivityContextType | undefined>(undefined);
ShowMoreActivityContext.displayName = "ShowMoreActivityContext";

export default ShowMoreActivityContext;
